@if (textUpozorneni) {
<div class="upozorneni">
  <i class="pi pi-exclamation-triangle warning-icon"></i>
  <span>{{ textUpozorneni }}</span>
</div>
}
